/**
 * @fileoverview GET handler for the "/app_settings/custom_event_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomEventUsage } from "./constants";
import type { AppSettingsCustomEventUsageResult } from "./types";
import { isAppSettingsCustomEventUsageResult } from "./validators";

export const getAppSettingsCustomEventUsage = reactQueryFetcherAdapter(
  appSettingsCustomEventUsage,
  (signal: AbortSignal): Promise<AppSettingsCustomEventUsageResult> => {
    return fetch("/app_settings/custom_event_usage", "GET", {}, { signal });
  },
  isAppSettingsCustomEventUsageResult
);
